// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.help-desk-new-conversation-button-content {
  display: inline-flex;
  -webkit-box-align: center;
  align-items: center;
}

.help-desk-new-conversation-button-content-svg {
  width: 15px;
  height: 16px;
}

.help-desk-new-conversation-button-content-svg path {
  fill: rgb(255, 255, 255);
}
`, "",{"version":3,"sources":["webpack://./dist/src/components/controls/start-chat/start-chat.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":[".help-desk-new-conversation-button-content {\r\n  display: inline-flex;\r\n  -webkit-box-align: center;\r\n  align-items: center;\r\n}\r\n\r\n.help-desk-new-conversation-button-content-svg {\r\n  width: 15px;\r\n  height: 16px;\r\n}\r\n\r\n.help-desk-new-conversation-button-content-svg path {\r\n  fill: rgb(255, 255, 255);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
